module.exports = [["male","Männlich"],["female","Weiblich"]]


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Gender.json
// module id = 130
// module chunks = 0